import apiClient from './api';

const authService = {
    async login(email, password) {
        const response = await apiClient.post('/auth/login', { email, password });
        if (response.data.access_token) {
            // Backend returns "Bearer <token>", so we strip the prefix to store only the raw token
            // This prevents api.js from adding a second "Bearer " prefix
            const token = response.data.access_token.replace('Bearer ', '');
            localStorage.setItem('token', token);
        }
        return response.data;
    },

    async signup(userData) {
        const response = await apiClient.post('/auth/signup', userData);
        return response.data;
    },

    logout() {
        localStorage.removeItem('token');
    },

    getCurrentUser() {
        // Implementation depends on backend, for now just check token
        return localStorage.getItem('token');
    },

    async forgotPassword(email) {
        const response = await apiClient.post('/auth/forgot-password', { email });
        return response.data;
    },

    async changePassword(currentPassword, newPassword) {
        const response = await apiClient.post('/auth/change-password', { currentPassword, newPassword });
        return response.data;
    },

    async resetPassword(token, newPassword) {
        const response = await apiClient.post('/auth/reset-password', { token, newPassword });
        return response.data;
    }
};

export default authService;
